import { useTheme } from '../hooks/useTheme';
import type { ThemeConfig } from '@ext-bookmark/shared/types';

/**
 * Hook to get sidebar theme configuration
 */
export function useSidebarTheme() {
  const { config } = useTheme();
  return config.sidebar;
}

// 默认主题配置
export const defaultThemeConfig: ThemeConfig = {
  mode: 'light',
  sidebar: {
    width: 120,
    opacity: 1,
    backgroundColor: '#1F2937', // gray-800
    textColor: '#F9FAFB', // gray-50
    activeColor: '#2563EB', // blue-600
    hoverColor: '#374151', // gray-700
    borderColor: '#374151', // gray-700
  },
  components: {},
  background: {
    type: 'gradient',
    colors: ['#F9FAFB', '#F3F4F6'],
  },
};

// iOS 风格浅色主题配置
export const iosLightTheme: ThemeConfig = {
  mode: 'light',
  sidebar: {
    width: 120,
    opacity: 0.95,
    backgroundColor: 'rgba(255, 255, 255, 0.75)', // iOS 毛玻璃效果，降低不透明度让背景更明显
    textColor: '#1C1C1E', // ios-gray-950
    activeColor: '#007AFF', // ios-blue
    hoverColor: 'rgba(0, 0, 0, 0.05)',
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  components: {},
  background: {
    type: 'gradient',
    colors: [
      '#E8F4F8', // 浅蓝色
      '#F0F8FF', // 天蓝色
      '#FFF5E6', // 浅橙色
      '#F5F0FF', // 浅紫色
    ],
  },
};

// iOS 风格深色主题配置
export const iosDarkTheme: ThemeConfig = {
  mode: 'dark',
  sidebar: {
    width: 120,
    opacity: 0.95,
    backgroundColor: 'rgba(28, 28, 30, 0.75)', // ios-gray-950 with opacity，降低不透明度
    textColor: '#F9F9F9', // ios-gray-50
    activeColor: '#007AFF', // ios-blue
    hoverColor: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'rgba(255, 255, 255, 0.1)',
  },
  components: {},
  background: {
    type: 'gradient',
    colors: [
      '#0A0A0C', // 深黑色
      '#1A1A2E', // 深蓝黑
      '#16213E', // 深蓝
      '#0F3460', // 深蓝灰
    ],
  },
};

// 浅色主题配置（保留兼容性）
export const lightTheme: ThemeConfig = {
  ...defaultThemeConfig,
  mode: 'light',
  background: {
    type: 'gradient',
    colors: ['#F9FAFB', '#F3F4F6', '#E5E7EB'],
  },
};

// 深色主题配置（保留兼容性）
export const darkTheme: ThemeConfig = {
  ...defaultThemeConfig,
  mode: 'dark',
  sidebar: {
    ...defaultThemeConfig.sidebar,
    backgroundColor: '#111827', // gray-900
    textColor: '#F9FAFB', // gray-50
    hoverColor: '#1F2937', // gray-800
    borderColor: '#1F2937', // gray-800
  },
  background: {
    type: 'gradient',
    colors: ['#111827', '#1F2937', '#374151'],
  },
};
